<rask-page
  pageTitle="{{ 'TERMINALORDER_LIST_SOK' | translate }}"
  [actionShow]="canEdit()"
  [actionFn]="create"
  actionTitle="{{'TERMINALORDER_LIST_SKAPA_NY' | translate}}"
  noPadding>
  <ng-container headerContent>
    @if (form) {
      <form [formGroup]="form" (ngSubmit)="search()">
        <div class="row">
          <rask-selector aid="inputMottagningsplats" class="col-2 search-fix" label="{{'TERMINALORDER_LIST_MOTTAGNINGSPLATS' | translate}}"
            formControlName="mottagningsplats"
            [minCharacters]="3"
            [debounceTime]="300"
            placeholder="Ange minst tre tecken"
            [getSelectionFromModel]="set"
            [search]="mottagningsplatsSearch"
            [viewFormatter]="viewFormatter"
            [formatter]="typeAheadValueFormatter"
            name="mottagningsplats">
          </rask-selector>
          <rask-input aid="inputBeskrivning" class="col-2" label="{{ 'KUNDORDER_LIST_BESKRIVNING' | translate }}"
            [value]="request.beskrivning" formControlName="beskrivning" name="beskrivning">
          </rask-input>
          <rask-datepicker aid="inputPeriodFrom" class="col-1" formControlName="periodFrom"
            label="{{'KUNDORDER_LIST_PERIODFROM' | translate}}" [minDate]="" [onlyMonths]="false" name="periodFrom">
          </rask-datepicker>
          <rask-datepicker aid="inputPeriodTom" class="col-1" formControlName="periodTom"
            label="{{'KUNDORDER_LIST_PERIODTOM' | translate}}" [minDate]="" [onlyMonths]="false" name="periodTom">
          </rask-datepicker>
          <rask-selector aid="inputAvtalsansvarig" class="col-2 search-fix" label="{{ 'KUNDORDER_LIST_AVTALSANSVARIG' | translate }}"
            formControlName="avtalsansvarig"
            [minCharacters]="3"
            [debounceTime]="300"
            placeholder="Ange minst tre tecken"
            [getSelectionFromModel]="set"
            [search]="avtalAnsvarigSearch"
            [viewFormatter]="viewFormatter"
            [formatter]="typeAheadValueFormatter"
            name="avtalsansvarig">
          </rask-selector>
          @if (handelssortiment?.length > 0) {
            <rask-tree-selector
              aid="inputHandelssortimentsgrupper"
              class="col-2"
              [label]="'KUNDORDER_LIST_HANDELSSORTIMENT' | translate"
              [items]="handelssortiment"
              [required]="false"
              [manualItemSync]="true"
              [syncOnClear]="true"
              formControlName="handelssortiment">
            </rask-tree-selector>
          }
          <rask-input
            aid="inputOrderNummer"
            class="col-2"
            label="{{ 'KUNDORDER_LIST_ORDERNUMMER' | translate }}"
            [value]="request.ordernummer"
            name="ordernummer"
            formControlName="ordernummer">
          </rask-input>
        </div>
        <div class="d-flex">
          <rask-submit-button aid="buttonSok" class="ps-0" color="secondary">{{ 'DEFAULT_BUTTON_LABEL_SOK' | translate }}</rask-submit-button>
          <rask-button aid="buttonClear" color="secondary" negative (click)="clear()">Rensa</rask-button>
        </div>
      </form>
    }
  </ng-container>
  <rask-terminalorder-list [terminalordrar]="terminalordrar"></rask-terminalorder-list>
</rask-page>
